module.exports = __webpack_public_path__ + "img/card_medical_office_200.09faa7de.jpg";